import type { DataChangeLogFiltersInput } from '../../graphql/api/generated';
import Model from '../Model';

export const DataChangeLogModel = new Model<DataChangeLogFiltersInput>({
  names: {
    schemaName: 'DataChangeLog',
    displayName: 'Data Change Log',
    pluralDisplayName: 'Data Change Logs',
  },
  permissionsOptions: {
    // This will actually be dependent on the "tableName" the query is filtered by
    canRead: () => true,
  },
});

export default DataChangeLogModel;
